import { Box } from '@mui/material';
import useAppTheme from 'hooks/useAppTheme';
import { FilterPanel } from './FilterPanel';
import { MaintenanceCostKpi } from './MaintenanceCostKpi';
import { MaintenanceCostDistribution } from './MaintenanceCostDistribution';
import { WorkOrders } from './WorkOrders';
import { DowntimeHours } from './DowntimeHours';
import { type Dispatch, type SetStateAction, useState } from 'react';
import { SingleFadeLoader } from 'components/SingleFadeLoader';
import { FrequentlyReplacedParts } from './FrequentlyReplacedParts';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

export const FilterDependentSection = ({
  selectedMonth,
  setSelectedMonth,
}: {
  selectedMonth: string | null;
  setSelectedMonth: Dispatch<SetStateAction<string | null>>;
}) => {
  const { enableDarkTheme } = useAppTheme();
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  const [isLoading, setIsLoading] = useState(true);
  return (
    <>
      <Box>
        <FilterPanel
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          selectedMonth={selectedMonth}
          setSelectedMonth={setSelectedMonth}
        />
      </Box>
      {isLoading ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '200px',
          }}
        >
          <SingleFadeLoader isFullScreen={false} />
          <div style={{ height: '20px' }} />
        </div>
      ) : (
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr',
            gridTemplateRows: '445px', // same height
            width: '100%',
            gap: '16px',
            backgroundColor: enableDarkTheme
              ? palette.pageBackground
              : palette.pageBackground,
          }}
        >
          <Box
            sx={{ height: '100%' }}
            display={'flex'}
            flexDirection={'column'}
            gap={2}
            width={'100%'}
          >
            <MaintenanceCostKpi />
            <MaintenanceCostDistribution />
          </Box>

          <Box
            sx={{ height: '100%' }}
            display={'flex'}
            flexDirection={'column'}
            gap={2}
            width={'100%'}
          >
            <DowntimeHours />
            <WorkOrders />
          </Box>

          <Box sx={{ height: '100%' }} width={'100%'}>
            <FrequentlyReplacedParts />
          </Box>
        </Box>
      )}
    </>
  );
};
